import React, { useEffect, useRef } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import Highcharts from "highcharts";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import more from "highcharts/highcharts-more";
import useCheckMobileScreen from "./useCheckMobileScreen";
more(Highcharts);
require("highcharts/modules/exporting.src");

const Gaugewithtwoaxes = (props) => {
  let gaugeheightandwidth = useCheckMobileScreen() ? "142" : "220";
  const mac = mqtt_topics.choosenmac;
  const chartRef = useRef(null);

  const [state, setState] = useStateIfMounted({
    value: 0,
    unit: props.unit,
    sunit: props.secondunit,
    title: props.title,
    minValue: props.min * 1,
    maxValue: props.max * 1,
    ratio: props.coefficient,
    limitover: 0,
    limitunder: 0,
    prelimitover: 0,
    prelimitunder: 0,
  });

  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic === target_live_reading_topic) {
      try {
        message = JSON.parse(message.toString());
        setState((prevState) => ({
          ...prevState,
          value:
            message.value === undefined || message.value === "---"
              ? 0
              : parseInt(message.value),
          limitover:
            message.limitover === undefined || message.limitover === "N"
              ? 0
              : message.limitover,
          limitunder:
            message.limitunder === undefined || message.limitunder === "N"
              ? 0
              : message.limitunder,
          prelimitover:
            message.prelimitover === undefined || message.prelimitover === "N"
              ? 0
              : message.prelimitover,
          prelimitunder:
            message.prelimitunder === undefined || message.prelimitunder === "N"
              ? 0
              : message.prelimitunder,
        }));
      } catch (error) {
        // Handle error
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
    return () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    };
  }, []);

  useEffect(() => {
    const redcolor = "rgba(200, 50, 50, .75)";
    const yellowcolor = "rgba(244, 155, 36, .75)";

    if (!chartRef.current) {
      chartRef.current = Highcharts.chart(
        state.title.replace(" ", "_") + "_canvas",
        {
          chart: {
            type: "gauge",
            height: gaugeheightandwidth,
            width: gaugeheightandwidth,
            alignTicks: false,
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false,
          },
          title: {
            text: "",
          },
          pane: {
            startAngle: -150,
            endAngle: 150,
          },
          yAxis: [
            {
              min: state.minValue,
              max: state.maxValue,
              lineColor: "#339",
              tickColor: "#339",
              minorTickColor: "#339",
              offset: -25,
              lineWidth: 2,
              labels: {
                distance: -20,
                rotation: "auto",
              },
              tickLength: 5,
              minorTickLength: 5,
              endOnTick: false,
              plotBands: [
                {
                  from: state.minValue,
                  to:
                    state.limitunder !== 0 ? state.limitunder : state.minValue,
                  color: redcolor,
                },
                {
                  from:
                    state.limitover !== 0 ? state.limitover : state.maxValue,
                  to: state.maxValue,
                  color: redcolor,
                },
                {
                  from:
                    state.prelimitunder !== 0
                      ? state.limitunder !== 0
                        ? state.limitunder
                        : state.minValue
                      : state.prelimitunder,
                  to: state.prelimitunder,
                  color: yellowcolor,
                },
                {
                  from: state.prelimitover,
                  to:
                    state.prelimitover !== 0
                      ? state.limitover !== 0
                        ? state.limitover
                        : state.maxValue
                      : state.prelimitover,
                  color: yellowcolor,
                },
              ],
            },
            {
              min: state.minValue,
              max: state.maxValue,
              tickPosition: "outside",
              lineColor: "#933",
              lineWidth: 2,
              minorTickPosition: "outside",
              tickColor: "#933",
              minorTickColor: "#933",
              tickLength: 5,
              minorTickLength: 5,
              labels: {
                distance: 12,
                rotation: "auto",
              },
              offset: -20,
              endOnTick: false,
            },
          ],
          series: [
            {
              name: state.title,
              data: [
                state.value > state.maxValue ? state.maxValue : state.value,
              ],
              dataLabels: {
                formatter: function () {
                  var kmh = this.y,
                    mph = Math.round(kmh * state.ratio);
                  return (
                    '<span style="color:#339">' +
                    kmh +
                    " " +
                    state.unit +
                    "</span><br/>" +
                    '<span style="color:#933">' +
                    mph +
                    " " +
                    state.sunit +
                    "</span>"
                  );
                },
                backgroundColor: {
                  linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1,
                  },
                  stops: [
                    [0, "#DDD"],
                    [1, "#FFF"],
                  ],
                },
              },
              tooltip: {
                valueSuffix: state.unit,
              },
              credits: { enabled: false },
            },
          ],
          credits: {
            enabled: false,
          },
        }
      );
    } else {
      const chart = chartRef.current;
      chart.series[0].setData(
        [state.value > state.maxValue ? state.maxValue : state.value],
        true
      );
      chart.yAxis[0].update({
        plotBands: [
          {
            from: state.minValue,
            to: state.limitunder !== 0 ? state.limitunder : state.minValue,
            color: redcolor,
          },
          {
            from: state.limitover !== 0 ? state.limitover : state.maxValue,
            to: state.maxValue,
            color: redcolor,
          },
          {
            from:
              state.prelimitunder !== 0
                ? state.limitunder !== 0
                  ? state.limitunder
                  : state.minValue
                : state.prelimitunder,
            to: state.prelimitunder,
            color: yellowcolor,
          },
          {
            from: state.prelimitover,
            to:
              state.prelimitover !== 0
                ? state.limitover !== 0
                  ? state.limitover
                  : state.maxValue
                : state.prelimitover,
            color: yellowcolor,
          },
        ],
      });
      chart.yAxis[1].update({
        min: state.minValue,
        max: state.maxValue,
      });
    }
  }, [
    state.value,
    state.minValue,
    state.maxValue,
    state.limitover,
    state.limitunder,
    state.prelimitover,
    state.prelimitunder,
    gaugeheightandwidth,
  ]);

  return (
    <div className="col">
      <div className="card text-center bg-light guagewithtwoaxes">
        <div className="card-header" style={{ fontSize: "12px" }}>
          {state.title}
        </div>
        <div className="card-body">
          <center>
            <div
              id={state.title.replace(" ", "_") + "_canvas"}
              style={{ fontSize: "12px" }}
            ></div>
          </center>
        </div>
        <div className="card-footer">
          <h5>
            {state.value + " "}
            <strong
              style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}
            >
              {state.unit}
            </strong>
          </h5>
          <br />
          <h5>
            {(state.value * state.ratio).toFixed(2) + " "}
            <strong
              style={{ fontSize: useCheckMobileScreen() ? "8px" : "12px" }}
            >
              {state.sunit}
            </strong>
          </h5>
        </div>
      </div>
    </div>
  );
};

export default Gaugewithtwoaxes;
